import { useState, useEffect } from 'react';
import { CordovaInfo } from '../types';

/**
 * Custom hook for Cordova integration
 * Handles device ready events, platform detection, and plugin access
 *
 * @returns CordovaInfo object with Cordova status and plugin access
 */
export const useCordova = (): CordovaInfo => {
  const [cordovaInfo, setCordovaInfo] = useState<CordovaInfo>({
    isCordova: !!window.cordova,
    deviceReady: false,
    platform: null,
    swiper: null,
    nativeStorage: null,
    plugins: null,
  });

  useEffect(() => {
    // Check if we're running in a Cordova environment
    if (!window.cordova) {
      return;
    }

    // Handle device ready event
    const handleDeviceReady = () => {
      const platform = window.device?.platform || null;
      const swiper = window.Swiper || null;
      const nativeStorage = window.NativeStorage || null;
      console.log(`handleDeviceReady...`);

      setCordovaInfo({
        isCordova: true,
        deviceReady: true,
        platform,
        swiper,
        nativeStorage,
        plugins: window.cordova?.plugins || null,
      });
    };

    // Check if device is already ready
    if (document.readyState === 'complete') {
      handleDeviceReady();
    } else {
      // Listen for device ready event
      document.addEventListener('deviceready', handleDeviceReady, false);
    }

    return () => {
      document.removeEventListener('deviceready', handleDeviceReady, false);
    };
  }, []);

  return cordovaInfo;
};
